<template>
  <div>
    <IQOS required :title="$t('stickers_checkout.contacts')">
      <div class="container-box mt-16">
        <div class="row">
          <div class="card-column">
            <BaseInput
              fullWidth
              v-model="form.firstname"
              :placeholder="$t('stickers_checkout.firstname_ph')"
              class="w-100"
            />
            <BaseInput
              fullWidth
              v-model="form.lastname"
              :placeholder="$t('stickers_checkout.lastname_ph')"
              class="w-100 mt-16"
            />
            <BaseInput
              fullWidth
              v-model="form.middlename"
              :placeholder="$t('stickers_checkout.middlename_ph')"
              class="w-100 mt-16"
              v-if="isNovaPoshtaAvailable"
            /><BaseInput
              fullWidth
              v-model="form.phone"
              :placeholder="$t('stickers_checkout.phone_ph')"
              class="w-100 mt-16"
            />

            <BaseSelect
              fullWidth
              v-model="delivery_way"
              :placeholder="$t('stickers_checkout.delivery_ph')"
              class="w-100 mt-16"
              v-if="!isLocalDelivery"
            >
              <option value="novaposhta" v-if="isNovaPoshtaAvailable">
                {{ $t("stickers_checkout.novaposhta") }}
              </option>
              <option value="courier">
                {{ $t("stickers_checkout.courier") }}
              </option>
            </BaseSelect>
            <BaseSelect
              v-model="form.warehouse"
              :placeholder="$t('stickers_checkout.warehouse')"
              class="w-100 mt-16"
              fullWidth
              v-if="delivery_way == 'novaposhta'"
            >
              <option :value="null">
                {{ $t("stickers_checkout.warehouse") }}
              </option>
              <option
                :value="warehouse.Description"
                v-for="warehouse in warehouses"
                :key="warehouse.Ref"
              >
                {{ warehouse.Description }}
              </option>
            </BaseSelect>
            <BaseInput
              :value="form.address"
              :placeholder="$t('stickers_checkout.address')"
              class="w-100 mt-16"
              fullWidth
              inputId="gmapAddressField"
              v-if="delivery_way == 'courier'"
            />
          </div>
          <div class="card-column ml-24">
            <BaseTextarea
              class="card-text-area"
              :readonly="false"
              :placeholder="$t('stickers_checkout.comment')"
              v-model="form.comment"
            />
            <!-- <BaseSelect
              :readonly="false"
              v-model="form.language"
              :placeholder="$t('stickers_checkout.language')"
              class="mt-16"
            >
              <option value="ua">Українська</option>
              <option value="ru">Русский</option>
              <option value="en">English</option>
            </BaseSelect> -->
          </div>
        </div>
      </div>
    </IQOS>

    <IQOS
      required
      :title="$t('stickers_checkout.order')"
      class="mt-32"
      v-if="hasDirectStickers || hasInsideStickers"
    >
      <template #actions>
        <span class="qrw-heading-xs v1-grey-6-color"> INSIDE </span>
      </template>

      <div class="cart-item-row mt-16" v-if="hasInsideStickers">
        <div class="cart-item-col v1-grey-6-color bold">
          {{ $t("stickers_checkout.col_design") }}
        </div>
        <div class="cart-item-col v1-grey-6-color bold">
          {{ $t("stickers_checkout.col_language") }}
        </div>
        <div class="cart-item-col v1-grey-6-color bold">
          {{ $t("stickers_checkout.col_hall") }}
        </div>
        <div class="cart-item-col v1-grey-6-color bold">
          {{ $t("stickers_checkout.col_table") }}
        </div>
        <div class="cart-item-col v1-grey-6-color bold">
          {{ $t("stickers_checkout.col_count") }}
          <div class="qrw-paragraph-xs">
            {{ $t("stickers_checkout.col_count_sub") }}
          </div>
        </div>
        <div class="cart-item-col v1-grey-6-color bold">
          {{ $t("stickers_checkout.col_price") }}
        </div>
        <div class="cart-item-col action-item-col v1-grey-6-color bold"></div>
      </div>
      <BaseDivider color="v1-grey-4" class="mt-16" v-if="hasInsideStickers" />
      <template v-for="(item, index) in cart">
        <div
          class="cart-item-row mt-16"
          :key="index"
          v-if="item.system == 'inside'"
        >
          <div class="cart-item-col">
            <BaseSelect
              fullWidth
              v-model="item.template"
              @blur="updateCartCache"
            >
              <option value="basic">Basic</option>
              <option value="hype">Hype</option>
              <option value="classic">Classic</option>
              <option value="custom" v-if="item.custom_url">Custom</option>
            </BaseSelect>
          </div>
          <div class="cart-item-col v1-grey-6-color bold">
            <BaseSelect
              fullWidth
              v-model="item.language"
              @blur="updateCartCache"
            >
              <option value="ua">Українська</option>
              <option value="ru">Русский</option>
              <option value="en">English</option>
            </BaseSelect>
          </div>
          <div class="cart-item-col v1-grey-6-color bold">
            {{
              (cafe.sections[item.section] || { name: item.section + 1 }).name
            }}
          </div>
          <div class="cart-item-col v1-grey-6-color bold">
            {{ item.table_name }}
          </div>
          <div class="cart-item-col v1-grey-6-color bold">
            <BaseInput
              fullWidth
              type="number"
              :valid="!!item.count"
              v-model.number="item.count"
              @blur="updateCartCache"
            />
          </div>
          <div class="cart-item-col v1-grey-10-color bold">
            {{ item.price * item.count }}₴
          </div>
          <div class="cart-item-col v1-grey-6-color bold action-item-col">
            <BaseButton
              @click="removeItem(index)"
              color="red-4"
              icon="trash"
              variant="secondary"
              size="md"
            />
          </div>
        </div>
        <BaseDivider
          :key="'d' + index"
          color="v1-grey-4"
          class="mt-16"
          v-if="item.system == 'inside' && index != cart.length-1"
        />
      </template>

      <div class="mt-16" v-if="hasDirectStickers">
        <BaseHeader>
          <template #title>
            {{ $t("stickers_checkout.order") }}
          </template>

          <template #actions>
            <span class="qrw-heading-xs v1-grey-6-color">
              {{ $t("stickers_checkout.direct_title") }}
            </span>
          </template>
        </BaseHeader>

        <div class="cart-item-row mt-16">
          <div class="cart-item-col v1-grey-6-color bold">
            {{ $t("stickers_checkout.col_design") }}
          </div>
          <div class="cart-item-col v1-grey-6-color bold">
            {{ $t("stickers_checkout.col_language") }}
          </div>
          <div class="cart-item-col v1-grey-6-color bold">
            {{ $t("stickers_checkout.col_count") }}
          </div>
          <div class="cart-item-col v1-grey-6-color bold">
            {{ $t("stickers_checkout.col_price") }}
          </div>
          <div class="cart-item-col action-item-col v1-grey-6-color bold"></div>
        </div>

        <template v-for="(item, index) in cart">
          <div
            class="cart-item-row mt-16"
            :key="index"
            v-if="item.system != 'inside'"
          >
            <div class="cart-item-col">
              <BaseSelect
                fullWidth
                v-model="item.template"
                @blur="updateCartCache"
              >
                <option value="basic">Basic</option>
                <option value="hype">Hype</option>
                <option value="classic">Classic</option>
                <option value="custom" v-if="item.custom_url">Custom</option>
              </BaseSelect>
            </div>
            <div class="cart-item-col v1-grey-6-color bold">
              <BaseSelect
                fullWidth
                v-model="item.language"
                @blur="updateCartCache"
              >
                <option value="ua">Українська</option>
                <option value="ru">Русский</option>
                <option value="en">English</option>
              </BaseSelect>
            </div>
            <!-- <div class="cart-item-col v1-grey-6-color bold">
              {{
                (cafe.sections[item.section] || { name: item.section + 1 }).name
              }}
            </div> -->
            <!-- <div class="cart-item-col v1-grey-6-color bold">
              {{ item.table_name }}
            </div> -->
            <div class="cart-item-col v1-grey-6-color bold">
              <BaseInput
                fullWidth
                type="number"
                :valid="!!item.count"
                v-model.number="item.count"
                @blur="updateCartCache"
              />
            </div>
            <div class="cart-item-col v1-grey-10-color bold">
              {{ item.price * item.count }}₴
            </div>
            <div class="cart-item-col v1-grey-6-color bold action-item-col">
              <BaseButton
                @click="removeItem(index)"
                color="red-4"
                icon="trash"
                variant="secondary"
                size="md"
              />
            </div>
          </div>
          <BaseDivider
            :key="'d' + index"
            color="v1-grey-4"
            class="mt-16"
            v-if="item.system != 'inside' && index != cart.length-1"
          />
        </template>
      </div>

      <BaseDivider class="mt-16 mb-16" color="v1-grey-7" />
      <div class="cart-subtotal v1-grey-10-color qrw-heading-md bold">
        <div>{{ $t("stickers_checkout.total") }}</div>
        <div>{{ cartTotal }}₴</div>
      </div>
      <div class="cart-pay-container mt-16">
        <BaseButton
          variant="primary"
          @click="sendOrder"
          :disabled="!canMakeOrder"
          color="green-6"
          size="lg"
        >
          {{ $t("stickers_checkout.pay") }}
        </BaseButton>
      </div>
      <div class="cart-pay-container mt-16">
        <p class="qrw-paragraph-md v1-grey-7-color">
          {{ $t("stickers_checkout.pay_hint") }}
        </p>
      </div>
    </IQOS>

    <form
      id="shipmentPaymentForm"
      method="POST"
      action="https://www.liqpay.ua/api/3/checkout"
      accept-charset="utf-8"
    >
      <input type="hidden" name="data" :value="pay_form.data" />
      <input type="hidden" name="signature" :value="pay_form.signature" />
    </form>
  </div>
</template>
<script>
import BlackInput from "./BlackInput.vue";
import BlackSelect from "./BlackSelect.vue";
import BlackTextarea from "./BlackTextarea.vue";
import BlackButton from "./BlackButton.vue";
import DashboardButton from "./DashboardButton.vue";

import ShipmentAPI from "@/api/shipment";

let gmapAutocomplete = null;

export default {
  components: {
    BlackInput,
    BlackSelect,
    BlackTextarea,
    BlackButton,
    DashboardButton,
  },
  data() {
    return {
      cart: [],
      form: {
        recipient: null,
        firstname: null,
        middlename: null,
        lastname: null,
        phone: null,
        warehouse: null,
        address: null,
        comment: null,
        language: "uk",
      },

      pay_form: {
        data: null,
        signature: null,
      },

      warehouses: [],

      delivery_way: null,
    };
  },
  mounted() {
    const cart_cache = window.localStorage.getItem("stickers_cart");

    if (cart_cache) this.cart = JSON.parse(cart_cache);

    if (!this.isNovaPoshtaAvailable) {
      this.delivery_way = "courier";
    } else {
      this.delivery_way = "novaposhta";
    }

    if (this.isNovaPoshtaAvailable) this.fetchWarehouses();

    if (this.isLocalDelivery) {
      this.form.recipient = this.$store.state.owner.name;
      this.form.phone = this.$store.state.owner.phone;
      this.form.address = this.cafe.address;
    }

    this.form.language = this.$i18n.locale;
  },
  methods: {
    getHallCount(item) {
      if (item.system == "direct") return item.count;
      let n = 0;
      if (item.section == -1) {
        n = this.cafe.sections.reduce(
          (acc, it) => acc + it.tables_list.length,
          0
        );
      } else if (this.cafe.sections.length > item.section) {
        n = this.cafe.sections[item.section].tables_list.length;
      }

      // return `${n} ${this.$t('stickers_card.tables_suffix')}`;
      return n;
    },
    getStickersCount(item) {
      if (item.count) return item.count;
      return this.getHallCount(item) * 3;
    },
    getStickersPrice(item) {
      if (item.template == "custom") {
        return this.getStickersCount(item) * 20;
      } else {
        return this.getStickersCount(item) * 10;
      }
    },
    updateCartCache() {
      window.localStorage.setItem("stickers_cart", JSON.stringify(this.cart));
    },
    removeItem(index) {
      this.cart.splice(index, 1);
      this.updateCartCache();
    },
    fetchWarehouses() {
      ShipmentAPI.getWarehouses(this.cafe.city)
        .then((data) => {
          this.warehouses = data.list;
        })
        .catch((error) => {
          this.$store.dispatch("showError", "warehouses_error");
        });
    },
    sendOrder() {
      if (this.delivery_way == "courier") {
        this.form.warehouse = null;
      }

      const tokens = [
        this.form.lastname,
        this.form.firstname,
        this.form.middlename,
      ];

      const recipient = tokens.filter((t) => !!t).join(" ");

      ShipmentAPI.putOrder({
        cafe_id: this.cafe._id,
        recipient,
        phone: this.form.phone,
        address: this.form.address,
        comment: this.form.comment,
        warehouse: this.form.warehouse,
        language: this.form.language,
        contents: this.cart,
      })
        .then((data) => {
          this.shipment = data.shipment;
          this.pay_form = data.form;

          this.$nextTick(() => {
            document.getElementById("shipmentPaymentForm").submit();
          });

          window.localStorage.removeItem("stickers_cart");
          // this.entering_info = false;
        })
        .catch((error) => {
          this.$store.dispatch("showError", "shipment_failed");
        });
    },
    getHallName(idx) {
      const section = this.cafe.sections[idx];

      if (!section) {
        return "-";
      }

      return section.name;
    },
    initGoogleWidget() {
      const el = document.getElementById("gmapAddressField");

      const autocomplete = new window.google.maps.places.Autocomplete(el, {
        types: ["geocode"],
      });

      autocomplete.setFields(["formatted_address"]);

      if (this.owner && this.owner.country) {
        autocomplete.setComponentRestrictions({
          country: this.owner.country.toLowerCase(),
        });
      }

      autocomplete.addListener(
        "place_changed",
        this.onGmapPlaceChange.bind(this)
      );

      gmapAutocomplete = autocomplete;
    },
    parseGooglePlaceResult(place) {
      this.form.address = place.formatted_address;

      console.log(`Parse Google place result`, this.form.address);
    },
    onGmapPlaceChange() {
      if (gmapAutocomplete) {
        const place = gmapAutocomplete.getPlace();

        this.parseGooglePlaceResult(place);
      }
    },
  },
  watch: {
    delivery_way() {
      if (this.delivery_way === "courier") {
        this.$nextTick(this.initGoogleWidget);
      }
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    isLocalDelivery() {
      return this.cafe.city == "Ужгород";
    },
    totalPrice() {
      const initial = this.cart.reduce(
        (acc, item) => acc + this.getStickersPrice(item),
        0
      );

      return Math.max(initial, 380);
    },
    isNovaPoshtaAvailable() {
      return this.$store.getters["worldwide/checkService"]("novaposhta");
    },
    canMakeOrder() {
      if (!this.form.firstname || !this.form.lastname) return false;

      if (this.isNovaPoshtaAvailable && !this.form.middlename) return false;

      if (
        !this.isLocalDelivery &&
        (!this.form.phone || !(this.form.address || this.form.warehouse))
      )
        return false;

      if (!this.cart.length) return false;

      return true;
    },
    cartTotal() {
      if (!this.cart) return 0;
      const pretotal = this.cart.reduce(
        (acc, item) => acc + item.count * item.price,
        0
      );
      const minimum_price = 380;

      return Math.max(minimum_price, pretotal);
    },
    hasInsideStickers() {
      return this.cart.some((it) => it.system == "inside");
    },
    hasDirectStickers() {
      return this.cart.some((it) => it.system != "inside");
    },
  },
};
</script>

<style scoped>
.row {
  display: flex;
}

.card-column {
  width: 100%;
}

.cart-item-row {
  display: flex;
  justify-content: space-between;

  column-gap: 8px;
}

.cart-item-col {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-flow: column;
}

.cart-subtotal {
  width: 100%;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
}

.cart-pay-container {
  text-align: center;
  width: 100%;
  justify-content: center;
  display: flex;
}

.action-item-col {
  width: 128px;
}

.card-text-area {
  height: 100%;
}
</style>
